import './App.css';
import { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HomePage, CompassLanding, CompassFeedback, CompassPolicy, CompassTerms, TidePostLanding, TidePostPolicy, SharedSpendLanding, SharedSpendWaitlist, SharedSpendPolicy, ShareTheLoadLanding, ShareTheLoadWaitlist, LetsGoLanding, LetsGoWaitlist } from './pages';

function App() {
  const lastEscTime = useRef(0);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      const now = Date.now();
      if (now - lastEscTime.current < 500) {
        window.location.href = '/admin';
      }
      lastEscTime.current = now;
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/compass" element={<CompassLanding />} />
        <Route path="/compass/privacy" element={<CompassPolicy />} />
        <Route path="/compass/terms" element={<CompassTerms />} />
        <Route path="/compass/feedback" element={<CompassFeedback />} />
        <Route path="/tide-post" element={<TidePostLanding />} />
        <Route path="/tide-post/privacy-policy" element={<TidePostPolicy />} />
        <Route path="/shared-spend" element={<SharedSpendLanding />} />
        <Route path="/shared-spend/waitlist" element={<SharedSpendWaitlist />} />
        <Route path="/shared-spend/privacy" element={<SharedSpendPolicy />} />
        <Route path="/share-the-load" element={<ShareTheLoadLanding />} />
        <Route path="/share-the-load/waitlist" element={<ShareTheLoadWaitlist />} />
        <Route path="/lets-go" element={<LetsGoLanding />} />
        <Route path="/lets-go/waitlist" element={<LetsGoWaitlist />} />
        {/* Track Habits was renamed Compass. firebase.json 301s these on direct loads;
            these cover in-app navigation. */}
        <Route path="/track-habits" element={<Navigate to="/compass" replace />} />
        <Route path="/track-habits/privacy" element={<Navigate to="/compass/privacy" replace />} />
        <Route path="/track-habits/terms" element={<Navigate to="/compass/terms" replace />} />
        <Route path="/track-habits/feedback" element={<Navigate to="/compass/feedback" replace />} />
        <Route path="/habit-tracker" element={<Navigate to="/compass" replace />} />
        <Route path="/habit-tracker/privacy" element={<Navigate to="/compass/privacy" replace />} />
        <Route path="/habit-tracker/terms" element={<Navigate to="/compass/terms" replace />} />
        <Route path="/habit-tracker-policy" element={<Navigate to="/compass/privacy" replace />} />
        <Route path="/habit-tracker-terms" element={<Navigate to="/compass/terms" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
